/**
 * Online UI API
 * # Summary Elisa B2B Online UI API  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OFFieldApi = 'Additional_Details_for_Field_Engineer__c' | 'Additional_Info_Back_Office__c' | 'Additional_Installation_Address_Details__c' | 'Billing_Account__c' | 'Billing_Account_Data__c' | 'Contract_period__c' | 'description__c' | 'Desired_Delivery_Date__c' | 'Desired_Delivery_Time__c' | 'Fault_Incident_Contact__c' | 'Installation_Address__c' | 'Installation_Contact__c' | 'one_time_charge__c' | 'Ordering_Contact__c' | 'Product_line__c' | 'recurring_charge__c' | 'Reference_Id_1__c' | 'Reference_Id_2__c' | 'Reference_Id_3__c' | 'Reference_Id_4__c' | 'Service_availability_contact__c' | 'Service_availability_customer_expenses__c' | 'Service_availability_delivery_time__c' | 'Service_availability_description__c' | 'Service_availability_ticket_ID__c' | 'support_knowledgebase_url__c' | 'Technical_Contact__c' | 'Zero_Balance_Details__c' | 'Zero_Balance_Reason__c';

export const OFFieldApi = {
    Additional_Details_for_Field_Engineer__c: 'Additional_Details_for_Field_Engineer__c' as OFFieldApi,
    Additional_Info_Back_Office__c: 'Additional_Info_Back_Office__c' as OFFieldApi,
    Additional_Installation_Address_Details__c: 'Additional_Installation_Address_Details__c' as OFFieldApi,
    Billing_Account__c: 'Billing_Account__c' as OFFieldApi,
    Billing_Account_Data__c: 'Billing_Account_Data__c' as OFFieldApi,
    Contract_period__c: 'Contract_period__c' as OFFieldApi,
    description__c: 'description__c' as OFFieldApi,
    Desired_Delivery_Date__c: 'Desired_Delivery_Date__c' as OFFieldApi,
    Desired_Delivery_Time__c: 'Desired_Delivery_Time__c' as OFFieldApi,
    Fault_Incident_Contact__c: 'Fault_Incident_Contact__c' as OFFieldApi,
    Installation_Address__c: 'Installation_Address__c' as OFFieldApi,
    Installation_Contact__c: 'Installation_Contact__c' as OFFieldApi,
    one_time_charge__c: 'one_time_charge__c' as OFFieldApi,
    Ordering_Contact__c: 'Ordering_Contact__c' as OFFieldApi,
    Product_line__c: 'Product_line__c' as OFFieldApi,
    recurring_charge__c: 'recurring_charge__c' as OFFieldApi,
    Reference_Id_1__c: 'Reference_Id_1__c' as OFFieldApi,
    Reference_Id_2__c: 'Reference_Id_2__c' as OFFieldApi,
    Reference_Id_3__c: 'Reference_Id_3__c' as OFFieldApi,
    Reference_Id_4__c: 'Reference_Id_4__c' as OFFieldApi,
    Service_availability_contact__c: 'Service_availability_contact__c' as OFFieldApi,
    Service_availability_customer_expenses__c: 'Service_availability_customer_expenses__c' as OFFieldApi,
    Service_availability_delivery_time__c: 'Service_availability_delivery_time__c' as OFFieldApi,
    Service_availability_description__c: 'Service_availability_description__c' as OFFieldApi,
    Service_availability_ticket_ID__c: 'Service_availability_ticket_ID__c' as OFFieldApi,
    support_knowledgebase_url__c: 'support_knowledgebase_url__c' as OFFieldApi,
    Technical_Contact__c: 'Technical_Contact__c' as OFFieldApi,
    Zero_Balance_Details__c: 'Zero_Balance_Details__c' as OFFieldApi,
    Zero_Balance_Reason__c: 'Zero_Balance_Reason__c' as OFFieldApi
};

